export default __webpack_public_path__ + "static/header-iconic-link-insights-link-icon1.url-8d1a311fcf18eca11875b1685e342091.svg";